import React from "react";

const Bajra = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Bajra</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>HHB - 67 (Hybrid) [Released in 05.11.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-2.0 kgs per acre.</td>
              <td>
                Suitable for late sowing. Last week June to end of July. As per
                the availability of rains.
              </td>
              <td>
                In drought conditions, one or two irrigations are sufficient.
              </td>
              <td>60-62 days.</td>
              <td>
                Drought resistant variety. Medium height, more sprouting.
                Lodging resistant, thin straw, healthy earheads and medium bold
                grain.
              </td>
              <td>Grains: 12.5; Dry fodder: 35 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HHB - 94 (Hybrid) [Released in 03.04.2000]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-2.0 kgs per acre.</td>
              <td>
                Suitable for early sowing. Mid June to mid July. As per the
                availability of rains.
              </td>
              <td>
                In drought conditions, one or two irrigations are sufficient.
              </td>
              <td>70-75 days.</td>
              <td>
                Plant height is around 180-220 cm. Thick earheads and medium
                bold grains. Resistant to major diseases and pests. Crop does
                not lodge and earheads do not shutter.
              </td>
              <td>Grains: 11-12; Dry fodder: 28-30 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HC - 20 (Composite) [Released in 04.09.2002]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-2.0 kgs per acre.</td>
              <td>Suitable for early sowing.</td>
              <td>
                In drought conditions, one or two irrigations are sufficient.
              </td>
              <td>80-83 days.</td>
              <td>
                Plant height is around 140-232 cm. Suitable for the irrigated
                and rainfed areas of Haryana. Good cooking and fodder quality.
                Lodging and stemborer resistant.
              </td>
              <td>Grains: 8-9; Dry fodder: 30-32 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HHB - 67 (Improved) [Released in 05.11.2005]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-2.0 kgs per acre.</td>
              <td>The time of June and July is suitable.</td>
              <td>
                In drought conditions, one or two irrigations are sufficient.
              </td>
              <td>More early maturing variety. 60-62 days.</td>
              <td>
                Suitable for Haryana State. Suitable for rainfed and irrigated
                areas. Round and candletype earheads, thin stem. Plant height is
                around 160-180 cm. Resistant to lodging. This variety is early,
                medium and late sown. Drought resistant.
              </td>
              <td>8 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>HHB - 197 [Released in 10.01.2008]</strong>
              </td>
            </tr>
            <tr>
              <td>1.5-2.0 kgs per acre.</td>
              <td>The time of June and July is suitable.</td>
              <td>
                If there is no rain, one or two rounds of irrigation are
                sufficient.
              </td>
              <td>More early maturing variety. 68-72 days.</td>
              <td>
                Suitable for irrigated and not irrigated areas. Good grain
                quality and gives more dry fodder. Resistant to Downy Mildew
                disease. Long bristtles on earheads due to which birds do not
                harm.
              </td>
              <td>14 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Bajra;
